module.exports = __webpack_public_path__ + "media/components/src/assets/images/arrow-book-detail/left-arrow-d8fd57afd34b80ee4321dd5ae54c9f90.svg";